import * as moment from 'moment';
import { LogLevel } from './log-level.enum';

export class LogEntry {
  timestamp: Date;
  level: LogLevel;
  message: any;

  constructor(level: LogLevel, message: any) {
    this.timestamp = new Date();
    this.level = level;
    this.message = message;
  }

  toString() {
    let message: string = this.message instanceof Object ? JSON.stringify(this.message, null, '\t') : this.message;
    return `[${moment(this.timestamp).format('HH:mm:ss')}] [${this.level}] ${message}\n`;
  }

  toConsoleLogEntry() {
    return [`[${moment(this.timestamp).format('HH:mm:ss')}]`, `[${this.level}]`, this.message];
  }
}



// WEBPACK FOOTER //
// ./src/app/services/logging/log-entry.model.ts